import { createFetchContext } from '@/modules/auto-fetch-contex'
import { welcomeMessageService } from '@/modules/creator-settings/welcome-messages/service/welcome-message-service'

export const {
  useWelcomeMessageService,
  DefaultWelcomeMessageFetchProvider,
  CustomWelcomeMessageFetchProvider,
} = createFetchContext('WelcomeMessageFetch', { welcomeMessageService })
